module.exports = "/ui/1bdeef92a2c873f9674990ddddcfa3dc.jpg";